import React from 'react';
import '../../../styles/DragAndDropFile.scss';
import classNames from 'classnames';
import { Button, EButtonType } from '../../Button';
import { IconCloseV2 } from '../../Icons';

interface Props {
  handleFile: (file: File) => void;
  buttonLabel: string;
  inputLabel: string;
  children?: React.ReactNode;
  className?: string;
  file: File;
  fileFormat: string;
  onRemove?: any;
}

export const DragDropFile = ({
  handleFile,
  buttonLabel,
  inputLabel,
  children,
  className,
  file,
  fileFormat,
  onRemove,
}: Props) => {
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };

  return file ? (
    <div className='form-file-upload'>
      <div className='files-list'>
        <div className='font-weight-bold font-20 row-with-border'>Files uploaded</div>
        <div className='row-with-border d-flex justify-content-between align-items-center'>
          <div>{file.name}</div>
          {onRemove && (
            <div className='cursor-pointer'>
              <IconCloseV2 onClick={onRemove} />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    <form
      className={classNames(['form-file-upload', className])}
      onDragEnter={handleDrag}
      onSubmit={(e) => e.preventDefault()}
    >
      <input
        ref={inputRef}
        type='file'
        className='input-file-upload'
        multiple={false}
        accept={fileFormat}
        onChange={handleChange}
      />
      <label
        className={classNames('label-file-upload', {
          'drag-active': dragActive,
        })}
        htmlFor='input-file-upload'
      >
        <div className='d-flex flex-column align-items-center'>
          <p>{inputLabel}</p>
          {children}
          <Button buttonType={EButtonType.InvertedPillMedium} className='upload-button mt-0' onClick={onButtonClick}>
            {buttonLabel}
          </Button>
        </div>
      </label>

      {dragActive && (
        <div
          className='drag-file-element'
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        ></div>
      )}
    </form>
  );
};
